var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIdia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    id: "interest-creation-large",
    "data-supported-dps": "48x48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h48v48H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 44h-6a2 2 0 01-2-2v-5h10v5a2 2 0 01-2 2z",
    fill: "#c07800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 37l8 .07a11.25 11.25 0 01.09-3.57 6.61 6.61 0 01.78-1.63 5.16 5.16 0 01.63-.69l.14-.12A11.75 11.75 0 0035 22.17a11 11 0 00-22 0v.06a11.43 11.43 0 004.13 8.66 10.73 10.73 0 011.77 2.79 9.47 9.47 0 01.8 3.08l.3.24",
    fill: "#f5bb5c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 5.82L14.42 9M36 5.82L33.58 9M24 2v4.77",
    fill: "none",
    stroke: "#5d3b01",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.91
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 44h-6a2.21 2.21 0 01-2-2.1V37h10v4.9a2.21 2.21 0 01-2 2.1z",
    fill: "none",
    stroke: "#5d3b01",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 38c0-3.63.41-4.47.41-4.47a6.34 6.34 0 011.89-3 12.84 12.84 0 001.28-1.38 11.86 11.86 0 001.81-3.24 11.39 11.39 0 00.65-3.7v-.06A11.1 11.1 0 0024 11h0a11.09 11.09 0 00-11 11.17v.06a11.39 11.39 0 00.65 3.7 11.86 11.86 0 001.81 3.24 12.84 12.84 0 001.28 1.38 6.34 6.34 0 011.89 3s.37.84.37 4.45",
    fill: "none",
    stroke: "#5d3b01",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdia);
export default __webpack_public_path__ + "static/media/idia.197b0521cc7ded3597e011d1845fbb91.svg";
export { ForwardRef as ReactComponent };